import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";

import { staticTexts } from "../../utils/Translate";
import { getStoryDate } from "../../utils/utils";

import "./liveText.m.css";

const LiveText = ({ story, lang = "en" }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const lastPublishedAt = get(story, ["last-published-at"], null);

  return isClosed ? (
    <div className="live-text" styleName="live-text">
      {staticTexts(lang).liveEndText} {lastPublishedAt ? getStoryDate(lastPublishedAt, lang) : ""}
    </div>
  ) : (
    <div className="live-text" styleName="live-text open-blog ">
      {staticTexts(lang).liveText}
    </div>
  );
};

LiveText.propTypes = {
  story: object.isRequired,
  lang: string,
};

export default LiveText;
